import React from "react";

export default function StatusPopup({ show, onClose, message, type = 'error' }) {
    if (!show) return null;

    const isError = type === 'error';

    const title = isError ? "Error" : "Success 🎉";
    const defaultMessage = isError
        ? "Something went wrong. Please try again."
        : "Operation completed successfully.";

    // CSS क्लास को अब टाइप के अनुसार निर्धारित किया गया है
    const headerClass = isError ? "error-header" : "success-header";
    const buttonClass = isError ? "error-btn" : "success-btn";

    return (
        // modal-backdrop और modal-box अब सामान्य क्लास हैं
        <div className="modal-backdrop">
            <div className="modal-box">

                {/* Header */}
                <div className={headerClass}>
                    <h2 className="title">{title}</h2>
                    <button className="statusPopup-close-btn" onClick={onClose}>&times;</button>
                </div>

                {/* Message */}
                <div className="status-content">
                    <p className="message">
                        {message || defaultMessage}
                    </p>
                </div>

                {/* Footer */}
                <div className="status-footer">
                    <button className={buttonClass} onClick={onClose}>OK</button>
                </div>

            </div>
        </div>
    );
}